import type { ButtonProps as MuiButtonProps } from '@mui/material/Button/Button';
import MuiButton from '@mui/material/Button/Button';
import type { FC } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export type ButtonProps = MuiButtonProps & { loading?: boolean };

export const Button: FC<ButtonProps> = ({ loading, startIcon, endIcon, children, ...props }) => (
  <MuiButton startIcon={loading ? null : startIcon} endIcon={loading ? null : endIcon} {...props}>
    {loading ? <CircularProgress size={'1rem'} /> : children}
  </MuiButton>
);
